import _styled from "@emotion/styled/base";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../../primitives/Avatar/components/Container.js';
export const Avatar = /*#__PURE__*/_styled(forwardRef(function Avatar({
  initials = '',
  size = 'small',
  ...restProps
}, ref) {
  return _jsx(Container, {
    ref: ref,
    size: size,
    ...restProps,
    children: initials
  });
}), process.env.NODE_ENV === "production" ? {
  target: "eixtugl0"
} : {
  target: "eixtugl0",
  label: "Avatar"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkF2YXRhci5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFNSSIsImZpbGUiOiJBdmF0YXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBqc3ggYXMgX2pzeCB9IGZyb20gXCJAZW1vdGlvbi9yZWFjdC9qc3gtcnVudGltZVwiO1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgZm9yd2FyZFJlZiB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IENvbnRhaW5lciB9IGZyb20gJy4uLy4uL3ByaW1pdGl2ZXMvQXZhdGFyL2NvbXBvbmVudHMvQ29udGFpbmVyLmpzJztcbmV4cG9ydCBjb25zdCBBdmF0YXIgPSBzdHlsZWQoZm9yd2FyZFJlZihmdW5jdGlvbiBBdmF0YXIoeyBpbml0aWFscyA9ICcnLCBzaXplID0gJ3NtYWxsJywgLi4ucmVzdFByb3BzIH0sIHJlZikge1xuICAgIHJldHVybiAoX2pzeChDb250YWluZXIsIHsgcmVmOiByZWYsIHNpemU6IHNpemUsIC4uLnJlc3RQcm9wcywgY2hpbGRyZW46IGluaXRpYWxzIH0pKTtcbn0pKSBgYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPUF2YXRhci5qcy5tYXAiXX0= */");